/**
 * The brand mark: the roofline, the chimney, four window panes and the heart, from
 * `faithfully-kept-business/brand/logo-mark.svg` with the geometry unchanged.
 *
 * The roof and chimney keep the brand gold and the heart the brand coral, because those are the
 * logo's own colours and appear nowhere else on a screen. The panes are `currentColor`, so the mark
 * takes the text colour of wherever it sits, which in the header is the brand ink. It sits beside
 * the words "Faithfully Kept", so it is hidden from assistive technology rather than read twice.
 */

/** The mark's viewBox is 320 wide and 166 tall, so the width follows the height and never stretches. */
const ASPECT = 320 / 166;

export function BrandMark({ className, height = 22 }: { className?: string; height?: number }) {
  const width = Math.round(height * ASPECT * 100) / 100;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 -16 320 166"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path
        d="M20 130 L160 24 L300 130"
        fill="none"
        stroke="#B48A4F"
        strokeWidth="11"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M214 36 L230 36 L230 77.0 L214 64.9 Z" fill="#B48A4F" />
      <rect x="139" y="64" width="18" height="18" rx="3" fill="currentColor" />
      <rect x="163" y="64" width="18" height="18" rx="3" fill="currentColor" />
      <rect x="139" y="88" width="18" height="18" rx="3" fill="currentColor" />
      <rect x="163" y="88" width="18" height="18" rx="3" fill="currentColor" />
      <path
        d="M222 26 C 204 15, 205 -7, 222 4 C 239 -7, 240 15, 222 26 Z"
        fill="none"
        stroke="#E4685C"
        strokeWidth="6.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
